var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import * as React from 'react';
import classNames from 'classnames';

import IconVerified from '../../icons/general/IconVerified';

import Label from '../label';
import LoadingIndicator from '../loading-indicator';
import Tooltip from '../tooltip';


import './TextInput.scss';

var TextInput = function TextInput(_ref) {
    var _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        description = _ref.description,
        error = _ref.error,
        errorPosition = _ref.errorPosition,
        hideLabel = _ref.hideLabel,
        hideOptionalLabel = _ref.hideOptionalLabel,
        inputRef = _ref.inputRef,
        isLoading = _ref.isLoading,
        isRequired = _ref.isRequired,
        isValid = _ref.isValid,
        label = _ref.label,
        labelTooltip = _ref.labelTooltip,
        rest = _objectWithoutProperties(_ref, ['className', 'description', 'error', 'errorPosition', 'hideLabel', 'hideOptionalLabel', 'inputRef', 'isLoading', 'isRequired', 'isValid', 'label', 'labelTooltip']);

    var classes = classNames(className, 'text-input-container', {
        'show-error': !!error
    });

    return React.createElement(
        'div',
        { className: classes },
        React.createElement(
            Label,
            {
                text: label,
                showOptionalText: !hideOptionalLabel && !isRequired,
                hideLabel: hideLabel,
                tooltip: labelTooltip
            },
            !!description && React.createElement(
                'i',
                { className: 'text-input-description' },
                description
            ),
            React.createElement(
                Tooltip,
                {
                    isShown: !!error,
                    text: error || '',
                    position: errorPosition || 'middle-right',
                    theme: 'error'
                },
                React.createElement('input', _extends({ ref: inputRef, required: isRequired }, rest))
            ),
            isLoading && !isValid && React.createElement(LoadingIndicator, { className: 'text-input-loading' }),
            isValid && !isLoading && React.createElement(IconVerified, { className: 'text-input-verified' })
        )
    );
};

TextInput.propTypes = {
    /** Add a class to the component */
    className: PropTypes.string,
    description: PropTypes.node,
    error: PropTypes.node,

    /** Renders error tooltip at the specified position (positions are those from Tooltip) */
    errorPosition: function errorPosition() {
        return (typeof bpfrpt_proptype_Position === 'function' ? bpfrpt_proptype_Position : PropTypes.shape(bpfrpt_proptype_Position)).apply(this, arguments);
    },
    hideLabel: PropTypes.bool,
    hideOptionalLabel: PropTypes.bool,
    inputRef: PropTypes.func,

    /** Renders a loading indicator within the component when true */
    isLoading: PropTypes.bool,
    isRequired: PropTypes.bool,

    /** Renders a green verified checkmark within the component when true */
    isValid: PropTypes.bool,

    /** Label displayed for the text input */
    label: PropTypes.node.isRequired,
    labelTooltip: PropTypes.node
};
TextInput.displayName = 'TextInput';

export default TextInput;
import { bpfrpt_proptype_Position } from '../tooltip';
import PropTypes from 'prop-types';